import { Icon } from '@chakra-ui/react';

export const Check = (props) => (
  <Icon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M3.28033 9.46967C2.98744 9.17678 2.51256 9.17678 2.21967 9.46967C1.92678 9.76256 1.92678 10.2374 2.21967 10.5303L5.71967 14.0303C6.01256 14.3232 6.48744 14.3232 6.78033 14.0303L15.7803 5.03033C16.0732 4.73744 16.0732 4.26256 15.7803 3.96967C15.4874 3.67678 15.0126 3.67678 14.7197 3.96967L6.25 12.4393L3.28033 9.46967Z"
      fill="currentColor"
    />
  </Icon>
);
